import {usePrimeVue} from 'primevue/config';
import {getDays, getMonths} from '@malt/dates';

export function setupCalendarTranslations(): void {
    const primevue = usePrimeVue();

    primevue.config = {
        ...primevue.config,
        locale: {
            ...primevue.config.locale,
            dayNames: getDays('long'),
            dayNamesShort: getDays('short'),
            dayNamesMin: getDays('short'),
            monthNames: getMonths('long'),
            monthNamesShort: getMonths('short'),
        },
    };
}
